import {singleUserAxios} from '../../../services/axios';
import { User } from '../types/UserData';


import { LoginRequestV2, VerifyUser } from '../types/LoginRequestV2';
import { ForgotPasswordRequest } from '../types/ForgotPassword';
import axios from '../../../services/axios';
const login = (loginRequest: LoginRequestV2) => {
    let url = `v4/login`
    if (loginRequest.loginVia === 'otp' || loginRequest.loginVia === 'forgot') {
        url = `v4/login/verify-otp`
    }
    return singleUserAxios.post(url, loginRequest)
        .then((res: any) => {
            
            // let user: User = res.responseObject;
            return Promise.resolve(res);
        })
}

const forgotPassword = (email:ForgotPasswordRequest, host:any) => {
    return singleUserAxios.put(`user/resetPassword`, {email,host})
        .then((res: any) => {
            let responseObj = res.responseObject;
            return Promise.resolve(responseObj);
        });
}

const resetPassword = (newPassword:any, passwordResetHash:any) => {
    return singleUserAxios.put(`user/resetPasswordFinal`, {newPassword, passwordResetHash})
        .then((res: any) => {
            let responseObj = res.responseObject;
            return Promise.resolve(responseObj);
        });
}
const newPassword = (email:any) => {
    return singleUserAxios.post(`user/resetPasswordFinal`, email)
        .then((res: any) => {
            let responseObj = res.responseObject;
            return Promise.resolve(responseObj);
        });
}

const teacherLogin = () => {
    return axios.post(`user/teacher-login`)
        .then((res: any) => {
            return Promise.resolve(res);
        });
}

const studentLogin = () => {
    return axios.post(`user/student-login`)
        .then((res: any) => {
            return Promise.resolve(res);
        });
}


const getTeacherToken = () => {
    return axios.get(`user/teacher-token`)
        .then((res: any) => {
            return Promise.resolve(res);
        });
}

const logout = () => {
    return axios.post(`v4/logout`)
        .then((res: any) => {
            return Promise.resolve(res);
        });
}


export const userServiceV2 = {
    login,
    forgotPassword,
    newPassword,
    resetPassword,
    teacherLogin,
    getTeacherToken,
    logout,
    studentLogin
}